import { render } from "./quickAction.vue?vue&type=template&id=181a4c9e"
import script from "./quickAction.vue?vue&type=script&lang=js"
export * from "./quickAction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__